import React, { useEffect } from 'react';
import Loader from '../layout/Loader';
import { useMyOrdersQuery } from '../../redux/api/bookingApi';
import { MDBDataTable } from 'mdbreact';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import MetaData from '../layout/MetaData';
import '../../css/orders.css';

const CurrentOrdersHome = () => {
  const { data, isLoading, error } = useMyOrdersQuery();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const orderSuccess = searchParams.get('order_success');

  useEffect(() => {
    if (orderSuccess) navigate('/me/orders');
  }, [orderSuccess]);

  const setOrders = () => ({
    columns: [
      { label: 'Order Status', field: 'orderStatus', sort: 'asc' },
      { label: 'Actions', field: 'actions', sort: 'asc' },
    ],
    rows: data?.orders
      ?.filter((o) => o.orderStatus !== 'Job Completed Successfully')
      .map((order) => ({
        orderStatus: order?.orderStatus,
        actions: (
          <Link to={`/me/booking/${order?._id}`} className="btn btn-primary btn-sm" id="order-view-admin-orders">
            <i className="fa fa-eye" id="order-view-logo" />
          </Link>
        ),
      })) || [],
  });

  const inProgressOrders = data?.orders?.filter((o) => o.orderStatus !== 'Job Completed Successfully');

  if (isLoading) return <Loader />;
  if (!inProgressOrders?.length) return null;

  return (
    <>
      <MetaData title="In Progress Bookings" />
      <div className="container py-4">
        <h3 className="text-center mb-3">{inProgressOrders.length} Active Booking(s)</h3>
        <div className="card p-3">
          <MDBDataTable
            data={setOrders()}
            className="px-3"
            id="user-orders-id"
            bordered
            striped
            hover
            paging={false}
            searching={false}
            responsive
          />
        </div>
      </div>
    </>
  );
};

export default CurrentOrdersHome;